import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { MobilityMyBudgetPage } from '@/pages/MobilityMyBudgetPage';
import { MobilityMyClaimsPage } from '@/pages/MobilityMyClaimsPage';

/**
 * Root route table for the employee mobility self-service portal.
 *
 * All routes render inside the shared {@link Layout}. Unknown paths and the
 * index route both redirect to the budget overview, which is the portal's
 * default landing page.
 *
 * @returns The application's route tree.
 */
export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Navigate to="/budget" replace />} />
        <Route path="budget" element={<MobilityMyBudgetPage />} />
        <Route path="claims" element={<MobilityMyClaimsPage />} />
        <Route path="*" element={<Navigate to="/budget" replace />} />
      </Route>
    </Routes>
  );
}
